import { PROGRAM_TYPE_CATEGORIES } from '@/constants/filters';

/**
 * Get emoji based on program category/type
 * @param {Object} program - Program object with name, types, categories, etc.
 * @returns {string} Emoji character
 */
/** Ensure value is an array (API/database may return string or single value) */
const toArray = (v) => {
  if (Array.isArray(v)) return v;
  if (v == null) return [];
  if (typeof v === 'string') return [v];
  return [v];
};

export const getCategoryEmoji = (program) => {
  if (!program) return '🎯';
  
  const categories = toArray(program.all_categories || program.categories);
  const types = toArray(program.types);
  const name = (program.name || '').toLowerCase();
  const category = (program.category || program.primary_category || '').toLowerCase();
  const summary = (program.editorialSummary?.text || program.description || '').toLowerCase();
  const allText = `${name} ${summary} ${category}`.toLowerCase();

  // Priority order for emoji selection (matches PROGRAM_TYPE_CATEGORIES)
  
  // 1. Camps (highest priority)
  if (allText.includes('camp') || 
      allText.includes('summer camp') || 
      allText.includes('day camp') ||
      allText.includes('overnight camp') ||
      allText.includes('sleepaway camp') ||
      types.includes('campground') ||
      categories.some(cat => String(cat).toLowerCase().includes('camp'))) {
    return PROGRAM_TYPE_CATEGORIES.camps.icon; // '🏕️'
  }
  
  // 2. Sports & Recreation
  if (allText.match(/sport|athletic|swim|soccer|basketball|baseball|tennis|football|volleyball|martial arts|gymnastics|fitness/) ||
      types.some(t => ['gym', 'sports_club', 'sports_complex', 'stadium', 'swimming_pool'].includes(String(t))) ||
      categories.some(cat => String(cat).toLowerCase().includes('sport'))) {
    return PROGRAM_TYPE_CATEGORIES.sportsRecreation.icon; // '⚽'
  }
  
  // 3. Schools & Education / STEM
  if (allText.match(/stem|science|coding|robot|tech|computer|engineering|math|academic|learning|school|academy/) ||
      types.some(t => ['school', 'university', 'library'].includes(String(t))) ||
      categories.some(cat => { const c = String(cat).toLowerCase(); return c.includes('education') || c.includes('stem'); })) {
    return PROGRAM_TYPE_CATEGORIES.schoolsEducation.icon; // '🏫'
  }
  
  // 4. Arts & Culture
  if (allText.match(/art|music|dance|drama|theater|creative|museum|gallery/) ||
      types.some(t => ['museum', 'art_gallery', 'performing_arts_theater'].includes(String(t))) ||
      categories.some(cat => { const c = String(cat).toLowerCase(); return c.includes('art') || c.includes('culture'); })) {
    return PROGRAM_TYPE_CATEGORIES.artsCulture.icon; // '🎨'
  }
  
  // 5. Community Centers
  if (allText.match(/ymca|ywca|boys girls club|community center|youth center|jcc/) ||
      types.includes('community_center') ||
      categories.some(cat => String(cat).toLowerCase().includes('community'))) {
    return PROGRAM_TYPE_CATEGORIES.communityCenters.icon; // '🏢'
  }
  
  // 6. Parks & Outdoor
  if (allText.match(/park|nature|outdoor|environmental|wildlife|hiking|adventure/) ||
      types.some(t => ['park', 'national_park', 'tourist_attraction'].includes(String(t))) ||
      categories.some(cat => { const c = String(cat).toLowerCase(); return c.includes('park') || c.includes('outdoor'); })) {
    return PROGRAM_TYPE_CATEGORIES.parksOutdoor.icon; // '🌲'
  }
  
  // Default fallback
  return '🎯';
};
